import alt from 'components/Dispatcher';
import { hashHistory } from 'react-router';
let $ = window.$;
class FeatureActions{
  fetchFeatures() {
    return true;
  }
  updateFeatures(features) {
    return {features};
  }
  fetchFeature(id) {
    return id;
  }
  updateFeature(res) {
    if(res.status) {
      this.fetchError(res);
      return false;
    } else {
      return res.result;
    }
  }
  fetchLoading() {
    return {loading: true};
  }
  fetchSuccess(res) {
    if(res.status) {
      this.fetchError(res);
    } else {
      this.updateFeatures(res.result);
    }
    return false;
  }
  refreshFeature(json) {
    $('#delModal').modal('hide');
    return true;
  }
  fetchError(res) {

    if(res.status === 403) {
      hashHistory.push('/login');
    }
    return res;
  }
  editFeature(params) {
    return params;
  }
  deleteFeature(id) {
    return id;
  }
  deleteFeatureSuccess(json) {
    if(json.status) {
      alert(json.msg);
    } else {
      this.refreshFeature(json)
    }
    $('#delModal').modal('hide');
    return true;
  }
}

export default alt.createActions(FeatureActions);



// WEBPACK FOOTER //
// ./src/actions/FeatureActions.js